import React, { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from '../ui/button';
import { Menu, X } from 'lucide-react';
import { NavLinks, Logo } from './NavComponents';

const WHATSAPP_LINK = 'https://wa.me/523312949249?text=Quiero%20mi%20menú%20digital%20para%20mi%20negocio';

// Animation constants
const navbarAnimation = {
  initial: { y: -100 },
  animate: { y: 0 },
};

const mobileMenuAnimation = {
  initial: { opacity: 0, height: 0 },
  animate: { opacity: 1, height: 'auto' },
  exit: { opacity: 0, height: 0 },
};

export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleScroll = useCallback(() => {
    setIsScrolled(window.scrollY > 20);
  }, [setIsScrolled]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const closeMobileMenu = useCallback(() => {
    setIsMobileMenuOpen(false);
  }, [setIsMobileMenuOpen]);

  return (
    <motion.nav
      {...navbarAnimation}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'glass-card border-b border-border/50' : ''
      }`}
    >
      <div className="container px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          <div className="flex items-center">
            <Logo />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <NavLinks />
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:block">
            <Button
              className="bg-gradient-to-r from-[hsl(var(--cta-orange))] to-[hsl(var(--cta-orange-hover))] text-white hover:shadow-[0_0_20px_hsl(var(--cta-orange)/0.4)] transition-all duration-300"
              onClick={() => window.open(WHATSAPP_LINK, '_blank')}
            >
              Comenzar ahora
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-secondary transition-colors"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            {...mobileMenuAnimation}
            className="md:hidden glass-card border-t border-border/50"
          >
            <div className="container px-4 py-4 space-y-3">
              <NavLinks isMobile onNavigate={closeMobileMenu} />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
};
